export const displayAnnotationAnchor = (annotationId) => {
  let annotationAnchorElement = document.querySelector(`.annotation-anchor-${annotationId}`);
  if (annotationAnchorElement) {
    annotationAnchorElement.style.display = 'block';
  }
};

export const hideAnnotationAnchor = (annotationId) => {
  let annotationAnchorElement = document.querySelector(`.annotation-anchor-${annotationId}`);
  if (annotationAnchorElement) {
    annotationAnchorElement.style.display = 'none';
  }
};
